<template>
    <div @click="$emit('select')"
         v-ripple
         class="chat-container"
         :class="[selectedRoom === chat._id ? 'chat-container__selected' : '']">
        <div class="chat-main-line">
          <div class="chat__name-container">
            <div class="chat__name">{{userName}}</div>

            <div class="chat__date">
              {{getDate()}}
            </div>
          </div>

          <span v-if="showNewMessageAlert">
            <template >
              <v-avatar color="red"
                        size="23px">
                <span class="white--text font-weight-bold"
                      style="font-size: 11px">
                  +1
                </span>
              </v-avatar>
            </template>
          </span>

          <span v-else>
            <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon class="ml-4"
                      :color="formatState(chat.state).color"
                      style="cursor: pointer;"
                      v-on="on">
                {{formatState(chat.state).icon}}
              </v-icon>
            </template>

            <span>
              {{formatState(chat.state).label}}
            </span>
          </v-tooltip>
          </span>
        </div>

        <div class="chat-main-line">
            <div class="chat__adviser"
                 :class="[chat.advisor && chat.advisor.name ? 'chat__with-adviser' : 'chat__without-adviser']">
                {{getAdviser}}
            </div>

            <div class="chat__channel"
                 :class="[chat.helpBot ? 'help-bot' : '']">
                {{chat.channel === 'smooch_wp' ? 'Whatsapp' : chat.channel}}
            </div>
        </div>

        <div class="chat__last-message-container">
            <div class="last-message">
                {{chat.lastMessage || $t('general.noMessage')}}
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
export default {
  computed: {
    ...mapState({
      selectedRoom: state => state.conversations.selectedRoom,
      userKeybe: state => state.auth.userKeybe
    }),
    showNewMessageAlert () {
      return this.chat.lastMessageFrom === 'user' && this.selectedRoom !== this.chat._id && this.chat.state !== 'ended'
    },
    userName () {
      if (this.chat.name) return this.chat.name
      if (this.chat.user) return this.chat.user.name
      return this.$t('general.nameless')
    },
    getAdviser () {
      if (!this.chat.advisor || !this.chat.advisor.name) return this.$t('general.withoutAdvisor')

      if (this.chat.advisor.userId === this.userKeybe.userId) return this.$t('general.you')
      return this.chat.advisor.name
    }
  },
  methods: {
    formatState (state) {
      if (state === 'readyForAdvisor') return { label: this.$t('general.waitingForAdvisor'), color: 'red', icon: 'mdi-clock' }
      if (state === 'ended') return { label: this.$t('general.finished'), color: 'green', icon: 'mdi-check' }
      if (state === 'withAdvisor') return { label: this.$t('general.withAdvisor'), color: 'yellow darken-2', icon: 'mdi-face-agent' }
      if (state === 'registered') return { label: this.$t('general.registered'), color: 'blue', icon: 'mdi-account-plus' }
      return { label: state, color: 'red' }
    },
    getDate () {
      return moment(this.chat.updatedAt).format('DD/MM/YYYY h:mm a')
    }
  },
  props: ['chat']
}
</script>

<style lang="scss">
    @import "../../../styles/Conversations/Chat.scss";
</style>
